import { Component, inject, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/alert-notify/alert-notify.service';
import { ConfirmationDialogService } from 'src/app/confirmation-dialog/confirmation-dialog.service';
import { AuthService } from 'src/services/auth.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';

@Component({
    selector: 'app-ecitation-user',
    templateUrl: './ecitation-user.component.html',
    styleUrls: ['./ecitation-user.component.css'],
    standalone: false
})
export class EcitationUserComponent {
	addNewUserForm: any = FormGroup
	editUserForm: any = FormGroup
	listAllUserType: any = []
	listAllUserRoles: any = []
	listAllAgency: any = []
	listAllUserDetails: any = []
	masterList: any = []
	listEditUserDetails: any = []
	loggedInUserName: any;
	userType: any='Destination';
	usreId: any
	alert: any
	mode = '';
	userTypeView:any;
	private modalService = inject(NgbModal);
	closeResult = '';

	constructor(private formBuilder: FormBuilder,
		private ecitationUserService: EcitationUserService,
		private confMsgService: ConfirmationDialogService,
		public alertService: AlertService,
		public authService: AuthService
	) { }

	ngOnInit() {
		let loginData = sessionStorage.getItem('loggedInUser');
		this.userTypeView = this.authService.getUserType();
		let item = loginData && JSON.parse(loginData)
		this.loggedInUserName = item?.username ?? ''
		this.editUserForm = this.formBuilder.group({
			firstName: [null, [Validators.required]],
			lastName: [null, [Validators.required]],
			email: [null, [Validators.required,Validators.email]],
			password: [null, [Validators.required]],
			userType: ['Destination', []],
			userRole: [null, [Validators.required]],
			username: [null, [Validators.required]],
			agency: [null, [Validators.required]],
		})
		this.allUserType();
		this.allUserRoles();
		this.getAllUsersDetails();
		this.getAgencyList('allOrganizations')

	}

	filterItems(searchQusery: string) {
		this.currentPage = 1;
		this.listAllUserDetails = this.masterList.filter((item: any) =>
			JSON.stringify(item).toLowerCase().includes(searchQusery.toLowerCase()))

	}

	pageSize: number = 25;
	currentPage: number = 1;

	getItems() {
		const satrtIndex = (this.currentPage - 1) * this.pageSize;
		return this.listAllUserDetails.slice(satrtIndex, satrtIndex + this.pageSize);
	}

	onPageChange(pageNumber: number) {
		this.currentPage = pageNumber
	}

	getTotalPages(): number {
		return Math.ceil(this.listAllUserDetails.length / this.pageSize);
	}

	getVisiblePages(): number[] {
		const totalVisiblePages = 10;
		const visiblePages: number[] = [];
		const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages / 2));
		const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
		for (let i = startPage; i <= endPage; i++) {
			visiblePages.push(i)
		}
		return visiblePages
	}

	allUserType() {
		this.ecitationUserService.allUserType().subscribe((res) => {
			this.listAllUserType = res
		})
	}

	allUserRoles() {
		this.ecitationUserService.allUserRoles().subscribe((res) => {
			this.listAllUserRoles = res
		})
	}

	getAllUsersDetails() {
		this.ecitationUserService.getAllUsersDetails().subscribe((res) => {
			this.listAllUserDetails = res
			this.masterList = res;
		})
	}

	getUserType(event: any, type: string) {
		if (this.mode == 'edit') {
			const oldVal = this.userType
			if (event !== oldVal) {
				const x = event
				this.getConfirmation(x, oldVal)
			}
		} else {
			const x = event;
			this.userType = x
			this.editUserForm.get('userRole').setValue(x)

			if (this.userType === 'Court') {
				this.getAgencyList('allCourts')
			} else if (this.userType === 'Vendor') {
				this.getAgencyList('allVendors')
			} else if (this.userType === 'Destination') {
				this.getAgencyList('allOrganizations')
			}
		}
	}
	getConfirmation(x: any, oldVal: any) {
		if(this.userType == 'S'){
		this.confMsgService.confirm('Are you sure?', 'Are you sure you want to Switch User Type ?').then((confirmed) => {
			if (confirmed) {
				this.userType = x
				this.editUserForm.get('userRole').setValue(x)

				if (this.userType === 'Court') {
					this.getAgencyList('allCourts')
				} else if (this.userType === 'Vendor') {
					this.getAgencyList('allVendors')
				} else if (this.userType === 'Destination') {
					this.getAgencyList('allOrganizations')
				}
			} else {
				this.userType = oldVal
				this.editUserForm.get('userRole').setValue(this.userType)
			}
		}).catch(() => {
			this.editUserForm.get('userRole').setValue(this.userType)
		})
	}
	else{
		this.confMsgService.confirm('Error','User type cannot be changed').then((confirmed) => {
			if (confirmed) {
				this.userType = oldVal
				this.editUserForm.get('userRole').setValue(this.userType)
			} else {
				this.userType = oldVal
				this.editUserForm.get('userRole').setValue(this.userType)
			}
		}).catch(() => {
			this.editUserForm.get('userRole').setValue(this.userType)
		})
	}
	}

	getAgencyList(userType: string) {
		this.ecitationUserService.getAgencyList(userType).subscribe((res: any) => {
			this.listAllAgency = res
		})
	}



	unlockUser(event: any, userName: string) {
		this.ecitationUserService.unlockUser(userName, this.loggedInUserName).subscribe((res) => {
			this.getAllUsersDetails()
		})
	}

	enableDisableUser(event: any, userName: string) {
		this.ecitationUserService.enableDisableUser(userName, this.loggedInUserName).subscribe((res) => {
			this.getAllUsersDetails()
		})
	}




	edit(contentda: TemplateRef<any>, mode: any, userId: number | null) {
		this.alert = null
		this.usreId = userId
		this.modalService.open(contentda, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);
		this.editUserForm.reset()
		this.mode = mode;
		document.getElementById('firstName')?.focus()
		if (mode == 'edit') {
			this.listEditUserDetails = this.listAllUserDetails.filter((key: any) => key.userId === userId)
			let firstName = this.listEditUserDetails[0].firstName
			let lastName = this.listEditUserDetails[0].lastName
			let email = this.listEditUserDetails[0].email
			let password = this.listEditUserDetails[0].password
			let appUserTypeDesc = this.listEditUserDetails[0].appUserTypeDesc
			let roleName = this.listEditUserDetails[0].roleName
			let username = this.listEditUserDetails[0].userName
			let agency = this.listEditUserDetails[0].agency
			this.userType = 'Destination'
			this.editUserForm = this.formBuilder.group({
				firstName: [firstName, [Validators.required]],
				lastName: [lastName, [Validators.required]],
				email: [email, [Validators.required,Validators.email]],
				password: [password, [Validators.required]],
				userType: ['Destination', []],
				userRole: [roleName, [Validators.required]],
				username: [username, [Validators.required]],
				agency: [agency, [Validators.required]],
			})
			this.editUserForm.controls.password.clearValidators()
			this.editUserForm.controls.password.updateValueAndValidity()
			if (this.userType === 'Court') {
				this.getAgencyList('allCourts')
			} else if (this.userType === 'Vendor') {
				this.getAgencyList('allVendors')
			} else if (this.userType === 'Destination') {
				this.getAgencyList('allOrganizations')
			}
		}

	}
	generatePass(type: string) {

		let password = this.generateRandomPassword(16);

		this.editUserForm.controls.password.setValidators([Validators.required])
		this.editUserForm.controls.password.setValue(password)
		this.editUserForm.markAsDirty()
		this.editUserForm.controls.password.updateValueAndValidity()

	}
	generateRandomPassword(length: number) {
		let charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		const randomValue = new Uint32Array(Math.ceil(length / 2));
		const crypto = window.crypto;
		crypto.getRandomValues(randomValue)
		let randomString = "";
		for (let i = 0; i < length; i++) {
			const randomIndex = randomValue[i % randomValue.length] % charset.length;
			randomString += charset[randomIndex]
		}
		return randomString
	}

	updateUser() {
		if (this.editUserForm.valid) {
			let formData = this.editUserForm.value;
			let data;
			if (this.mode === 'add') {
				data = {
					roleName: formData.userRole,
					firstName: formData.firstName,
					lastName: formData.lastName,
					email: formData.email,
					appUserTypeDesc:'Destination',
					userName: formData.username,
					password: formData.password,
					agency: formData.agency,
					loggedInUserName: this.loggedInUserName,
				}
			} else {
				data = {
					userId: this.usreId,
					roleName: formData.userRole,
					firstName: formData.firstName,
					lastName: formData.lastName,
					email: formData.email,
					appUserTypeDesc: 'Destination',
					userName: formData.username,
					password: formData.password,
					agency: formData.agency,
					loggedInUserName: this.loggedInUserName,
				}
			}
			this.ecitationUserService.addNewUser(data).subscribe((res: any) => {
				if (res.errorMessage && res.errorMessage !== '') {
					this.alert = {

						message: res.errorMessage,

					}
				} else {
					this.alert = null
					this.modalService.dismissAll()
					this.alertService.success(this.mode === 'add' ? `New user - ${formData.username} added sucessfully` : ` ${formData.username} updated sucessfully `)
					const filterInp  = document.getElementById('inputPassword6') as HTMLInputElement;
					if(filterInp){
						filterInp.value ='';
					}
					this.getAllUsersDetails()
				}

			})
		} else {
			for (let props in this.editUserForm.controls) {
				this.editUserForm.get(props).markAsTouched()
			}
		}
	}
	onSort(event: any, name: any, isSortable: boolean) {
		if (isSortable) {
			let spanEle = event.target.querySelector('i') != null ? event.target.querySelector('i') : event.target,
				classList = spanEle.classList;
			let sortDir = 1;
			if (classList.contains('fa-sort') || classList.contains('fa-sort-up')) {
				classList.remove('fa-sort')
				classList.remove('fa-sort-up')
				classList.add('fa-sort-down')
				sortDir = -1
			} else {
				classList.add('fa-sort-up')
				classList.remove('fa-sort-down')

			}
			this.sortBy(name, sortDir)
		}
	}
	sortBy(name: string, order: number) {
		this.listAllUserDetails.sort((a: any, b: any) => {
			a = isNaN(a[name]) ? String(a[name]).toLowerCase() : Number(a[name]);
			b = isNaN(b[name]) ? String(b[name]).toLowerCase() : Number(b[name]);
			if (order == 1) {
				return a < b ? -1 : (a > b ? 1 : 0)
			} else {
				return b < a ? -1 : (b > a ? 1 : 0)
			}
		})
	}
	private getDismissReason(reason: any): string {
		switch (reason) {
			case ModalDismissReasons.ESC:
				return 'by pressing ESC';
			case ModalDismissReasons.BACKDROP_CLICK:
				return 'by clicking on a backdrop';
			default:
				return `with: ${reason}`;
		}
	}





}
